var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.backgroundGradient),attrs:{"id":"app"},on:{"mousemove":_vm.redefinePositions,"mouseleave":_vm.resetPositions}},[_c('Header'),_c('div',{staticClass:"view"},[_c('RouterView')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }